import { httpClient } from "./BaseApi";

const DASHBOARD_DATA_URL = "api/member/dashboard/item.json";
const GET_DENTIST_URL = "api/member/dashboard/dentist.json";
const GET_PROFILE_URL = "api/member/dashboard/profile.json";

const DashboardApi = {
  getDentist: (params) => httpClient.get(GET_DENTIST_URL, { params }),
  getProfile: (params) => httpClient.get(GET_PROFILE_URL, { params }),
  getDashboardData: (params) => httpClient.get(DASHBOARD_DATA_URL, { params }),
};

export default DashboardApi;
